export default "__VITE_ASSET__FYSGGDqEzeMCxBJJaNSurg__";